import { Column, Editors, FieldType, GridOption, OnCellChangeEventArgs, OnClickEventArgs, OnEventArgs } from 'slickgrid-react'
import { InputEditor } from '@slickgrid-universal/common';

const TextEditor = Editors.text
// export default TextEditor

export default class CustomTextEditor extends InputEditor {
  constructor(args: any) {
    super(args);
  }

  loadValue(item: any): void {
      super.loadValue(item);
      
      // 确保 $input 存在
      if (this._input) {
        // 设置光标位置到文本末尾
        const value = this._input.value;
        console.log("value",value)
        if (typeof value === 'string') {
          setTimeout(() => {
            this._input.setSelectionRange(value.length, value.length);
          }, 0);
        }
        
        // 或者完全禁用文本选择
        // this.$input.off('focus.selectAll');
        // this.$input.on('focus', (event: any) => {
        //   event.preventDefault();
        //   const input = event.target;
        //   input.setSelectionRange(input.value.length, input.value.length);
        // });
      }
  }
}